var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"inputRef",staticClass:"entsys--white-background-input",attrs:{"value":_vm.formattedValue,"data-test":_vm.dataTest,"clearable":"","outlined":""},on:{"change":v => _vm.$emit('change', v),"click:clear":() => _vm.$emit('input', null),"blur":$event => {
      _vm.$emit('blur', $event);
    }},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_vm._t("append-outer")]},proxy:true}],null,true)},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }